export const mockGraphData = {
  nodes: [
    { id: 'p1', label: 'cat1.jpg', group: 0 },
    { id: 'p2', label: 'cat2.jpg', group: 0 },
    { id: 'p3', label: 'night_cat.jpg', group: 0 },
    { id: 'p4', label: 'download_2.jpg', group: 0 },
    { id: 'p5', label: 'food.jpg', group: 0 },
    { id: 'p6', label: 'food1.jpg', group: 0 },
    { id: 'p7', label: 'food3.jpg', group: 0 },
    { id: 'p8', label: 'dog.jpg', group: 0 },
    { id: 'p9', label: 'dog_cat.jpg', group: 0 },
    { id: 'p10', label: 'download1.jpg', group: 0 },
    { id: 'p11', label: 'download2.jpg', group: 0 },
    { id: 'p12', label: 'download3.jpg', group: 0 },
    { id: 'p13', label: 'person.jpg', group: 0 },

    { id: 'happy', label: '행복함', group: 1 },
    { id: 'cat', label: '고양이', group: 1 },
    { id: 'dog', label: '강아지', group: 1 },
    { id: 'whisker', label: '수염', group: 1 },
    { id: 'mammal', label: '육식동물', group: 1 },
    { id: 'night', label: '밤', group: 1 },
    { id: 'summer', label: '여름', group: 1 },
    { id: 'winter', label: '겨울', group: 1 },
    { id: 'time19', label: '19시', group: 1 },
    { id: 'month12', label: '12월', group: 1 },
    { id: 'day10', label: '10일', group: 1 },
    { id: 'chair', label: '의자', group: 1 },
    { id: 'color', label: '초록색', group: 1 },
    { id: 'color_1', label: '검은색', group: 1 },
    { id: 'food', label: '음식', group: 1 },
    { id: 'yolk', label: '노른자', group: 1 },
    { id: 'french_fries', label: '감자튀김', group: 1 },
    { id: 'chicken', label: '치킨', group: 1 },
    { id: 'time11', label: '11시', group: 1 },
    { id: 'time13', label: '13시', group: 1 },

    { id: 'person', label: '인물', group: 2 },
    { id: 'person1', label: '인물1', group: 2 },
    { id: 'person2', label: '인물2', group: 2 },
    { id: 'person3', label: '인물3', group: 2 },
    { id: 'person4', label: '인물4', group: 2 },
    { id: 'tag_tie', label: '넥타이', group: 1 },
    { id: 'glasses', label: '안경', group: 1 },
    { id: 'woman', label: '여자', group: 2 },
    { id: 'man', label: '남자', group: 2 },
  ],
  links: [
    { source: 'p1', target: 'cat', type: '동물' },
    { source: 'p1', target: 'chair', type: '가구' },
    { source: 'p1', target: 'color', type: '색' },
    { source: 'p1', target: 'mammal', type: '동물' },

    { source: 'p2', target: 'cat', type: '동물' },
    { source: 'p2', target: 'whisker', type: '신체_부분' },
    { source: 'p2', target: 'mammal', type: '동물' },
    { source: 'p2', target: 'color_1', type: '색' },

    { source: 'p3', target: 'night', type: '밤/낮' },
    { source: 'p3', target: 'summer', type: '계절' },
    { source: 'p3', target: 'time19', type: '시' },
    { source: 'p3', target: 'cat', type: '동물' },
    { source: 'p3', target: 'mammal', type: '동물' },

    // { source: 'p4', target: 'person', type: '인물' },
    { source: 'p4', target: 'person1', type: '인물' },
    { source: 'p4', target: 'tag_tie', type: '의류' },
    { source: 'p4', target: 'woman', type: '성별' },

    { source: 'p5', target: 'summer', type: '계절' },
    { source: 'p5', target: 'food', type: '음식' },

    { source: 'p6', target: 'summer', type: '계절' },
    { source: 'p6', target: 'food', type: '음식' },
    { source: 'p6', target: 'yolk', type: '음식' },
    { source: 'p6', target: 'time11', type: '시' },

    { source: 'p7', target: 'summer', type: '계절' },
    { source: 'p7', target: 'food', type: '음식' },
    { source: 'p7', target: 'chicken', type: '음식' },
    { source: 'p7', target: 'french_fries', type: '음식' },

    { source: 'p8', target: 'dog', type: '동물' },
    { source: 'p8', target: 'mammal', type: '동물' },
    { source: 'p8', target: 'winter', type: '계절' },
    { source: 'p8', target: 'chair', type: '가구' },
    { source: 'p8', target: 'month12', type: '월' },
    { source: 'p8', target: 'day10', type: '일' },
    { source: 'p8', target: 'time13', type: '일' },

    { source: 'p9', target: 'dog', type: '동물' },
    { source: 'p9', target: 'cat', type: '동물' },
    { source: 'p9', target: 'mammal', type: '동물' },

    // { source: 'p10', target: 'person', type: '인물' },
    { source: 'p10', target: 'person2', type: '인물2' },
    { source: 'p10', target: 'man', type: '성별' },

    // { source: 'p11', target: 'person', type: '인물' },
    { source: 'p11', target: 'person2', type: '인물2' },
    { source: 'p11', target: 'person3', type: '인물3' },
    { source: 'p11', target: 'man', type: '성별' },
    { source: 'p11', target: 'glasses', type: '안경' },

    // { source: 'p12', target: 'person', type: '인물' },
    { source: 'p12', target: 'person3', type: '인물3' },
    { source: 'p12', target: 'man', type: '성별' },
    { source: 'p12', target: 'glasses', type: '안경' },

    { source: 'p13', target: 'person4', type: '인물4' },
    { source: 'p13', target: 'man', type: '성별' },
    { source: 'p13', target: 'happy', type: '감정' },
  ],
};
